<template>
  <el-aside width="200px">
    <el-menu class="submenu" @select="handleSelect" :default-active="activeIndex">
      <h1>创说会</h1>
      <el-menu-item index="businessExplanation" v-if="actManage">
        <template slot="title" class="sub">活动管理</template>
      </el-menu-item>
      <el-menu-item index="luckDrawSetting" v-if="lotAllocation">
        <template slot="title" class="sub">抽奖配置</template>
      </el-menu-item>
      <el-submenu index="spaekMeetingCount" v-if="actStatistics">
        <template slot="title" class="sub">活动统计</template>
        <el-menu-item index="mechanismStatistics">
          <span>机构统计</span>
        </el-menu-item>
        <el-menu-item index="activityStatistics">
          <span>活动统计</span>
        </el-menu-item>
        <el-menu-item index="salesmanStatistics">
          <span>业务员统计</span>
        </el-menu-item>
        <el-menu-item index="salesmanDetails">
          <span>业务员明细</span>
        </el-menu-item>
        <el-menu-item index="participant">
          <span>参与人员</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: "speakingSidebar",
  props: {
    children: {
      type: Array
    }
  },
  //        初始化定义变量
  data() {
    return {
      activeIndex: "businessExplanation",
      show: true,
      actManage: false,
      lotAllocation: false,
      actStatistics: false
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if(keyPath.length === 1){
        if(key === 'businessExplanation'){
          this.$router.push('/home/speaking/management/businessExplanation')
        }else {
          this.$router.push('/home/speaking/'+ key)
        }
      }else {
        this.$router.push('/home/speaking/' + keyPath[0] + '/' + keyPath[1])
      }
      this.$emit('go_Speaking');
    }
  },
  watch: {
    children() {
      this.children.forEach(element => {
        if (element.privName == "活动管理") {
          this.actManage = true;
        }
        if (element.privName == "抽奖配置") {
          this.lotAllocation = true;
        }
        if (element.privName == "活动统计") {
          this.actStatistics = true;
        }
      });
    } 
  }
};
</script>

<style lang="scss" scoped>
.submenu {
  background: rgba(247, 247, 247, 1);
  h1 {
    text-align: center;
    font-size: 18px;
    color: rgba(153, 153, 153, 1);
    height: 100px;
    line-height: 100px;
    padding: 0;
    margin: 0;
    font-weight: normal;
  }
  .el-menu,
  .el-dropdown-menu__item--divided:before,
  .el-menu,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background-color: #f7f7f7;
  }
  // 单级导航的二级菜单
  > .el-menu-item {
    color: #5876b9;
    padding-left: 20% !important;
    border-top: 1px solid #e5e5e5;
    &:focus,
    &:hover {
      background-color: #5b9fec;
      color: #fff;
    }
  }
  // 多级别导航的二级菜单
  /deep/ .el-submenu__title {
    color: #5876b9;
    border-top: 1px solid #e5e5e5;
    height: 58px;
    line-height: 58px;
    padding-left: 20% !important;

    &:focus,
    &:hover {
      background-color: #5b9fec;
      color: #fff;
    }
    //三级导航
    + .el-menu .el-menu-item {
      background-color: #f7f7f7;
      &:active,
      &:focus,
      &:hover {
        background-color: #f7f7f7;
        color: #999;
        span {
          color: #409eff;
          &:after
         {
            color: #409eff;
          }
           &:before {
             background-color: #409eff;
           }
        }
      }
    }
  }
 
}

.el-aside {
  background: rgba(247, 247, 247, 1);
  -webkit-box-shadow: 3px 0px 5px 0px rgba(162, 187, 225, 0.3);
  box-shadow: 3px 0px 5px 0px rgba(162, 187, 225, 0.3);
  height: 100%;
  // height: calc(100% - 60px);
  width: 200px;
  // position: absolute;
  // top: 60px;
  z-index: 999;
}
.el-submenu .el-menu-item span {
  position: relative;
  display: block;
  color: #999;
  padding-left: 20%;
}
.el-submenu .el-menu-item span:before {
  content: "";
  position: absolute;
  background-color: #e4e7ed;
  border-radius: 50%;
  z-index: 10;
  width: 10px;
  height: 10px;
  top: 20px;
  left: 0px;
}
.el-submenu .el-menu-item span:after {
  content: "";
  position: absolute;
  left: 4px;
  height: 100%;
  border-left: 2px solid #e4e7ed;
  z-index: 9;
}
.el-submenu .el-menu-item:first-child span:after {
  top: 20px;
}
.el-submenu .el-menu-item:last-child span:after {
  bottom: 20px;
}


// @media screen and (max-width: 1024px) {
//   .el-aside {
//     top: 50px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/layout/SpeakingSidebar.vue